module.exports = __webpack_public_path__ + "app/principal/modals/modal-container-update-confirm-2XH88XZY.html";